import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/user/$userId")({
  loader: async ({ context, params }) => {
    const { preloadUserProfileRoute } = await import(
      "~/features/user-profile/user-profile-route"
    );
    await preloadUserProfileRoute(context, params.userId);
  },
});
